<template>
	<div>
		<v-card width="400" class="mx-auto mt-5">
			<v-card-text class="pb-1">
        <v-row align="center" justify="center">
          <v-col class="py-0 d-flex justify-center">
            <v-img src="img/icons/android-chrome-192x192.png" max-height="200" max-width="200"></v-img>
          </v-col>
        </v-row>
				<v-form ref="loginForm" v-model="formValidity" @submit="submitForm">
          <v-row>
            <v-col class="mx-0 py-0 primary--text"><h4>Email</h4></v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-text-field
                v-model.trim="email"
                :rules="emailRules"
                required
                outlined
                dense
                autocomplete
                name="email"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="mx-0 py-0 primary--text"><h4>Password</h4></v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-text-field
                v-model.trim="password"
                :rules="passwordRules"
                required
                outlined
                dense
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
              />
            </v-col>
          </v-row>
          <button type="submit" style="display: none;"></button>
				</v-form>
			</v-card-text>
			<v-card-text class="py-0 text-center">
        <v-row>
          <v-col class="py-0">
				<v-btn large color="info" @click="login" :disabled="!formValidity">Login</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-1">
          <a class="secondary--text text-decoration-none" @click="resetDlg = true"><small>Forgot your password?</small></a>
          </v-col>
        </v-row>
			<v-divider></v-divider>
        <v-row>
          <v-col class="pt-5">
            <v-btn color="success" to="/signupclient">Signup to request a booking</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0">
            <v-btn color="success" to="/signup">Signup as a vendor</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-1">
            (Includes agents, artists, and musicians)
          </v-col>
        </v-row>
			</v-card-text>
			<v-divider></v-divider>
      <v-card-text>
        <h4 class="text-center"><em>Powered by Ivystone Records Inc</em></h4>
      </v-card-text>
		</v-card>

   <v-dialog light v-model="resetDlg" persistent max-width="300" overlay-opacity=.7>
      <v-card>
        <v-card-text class="text-right pr-1 pb-0"><v-btn icon @click="resetDlg = false"><v-icon dark right>mdi-close-circle</v-icon></v-btn></v-card-text>
        <v-card-title class="justify-center pt-0">Reset Password</v-card-title>
        <v-card-text class="text-center">Enter your BookMe email. Click the button and we will email you a password reset link.</v-card-text>
        <v-form class="text-center ma-4" ref="resetForm" v-model="validResetForm">
          <v-text-field
            v-model.trim="resetEmail"
            type="email"
            :rules="resetEmailRules"
            label="Email"
            outlined
            solo
            color="primary"
            dense
            class="f-rounded"
            validate-on-blur
          ></v-text-field>
        </v-form>
        <v-card-actions class="justify-center mx-4 pb-4">
          <v-btn color="primary" block style="border-radius: 10px" class="text-none" @click="resetPassword">Email Reset Link</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
	name: 'Login',
	data() {
		return {
			email: "",
			emailRules: [
				value => !!value || 'Email is required'
			],
			password: "",
			passwordRules: [
				value => !!value || 'Password is required'
			],
			formValidity: false,
      showPassword: false,
      resetDlg: false,
			resetEmail: "",
      resetEmailRules: [
        value => !!value || 'Email is required.',
        value => value.indexOf('@') !== 0 || 'Email should have a username.',
        value => value.includes('@') || 'Email should include an @ symbol.',
        // value =>
        //   value.indexOf('.') - value.indexOf('@') > 1 ||
        //   'Email should contain a valid domain.',
        value => value.includes('.') || 'Email should include a period symbol.',
        value =>
          value.indexOf('.') <= value.length - 3 ||
          'Email should contain a valid domain extension.'
      ],
      validResetForm: false
    }
  },
  created() {
  },
  computed: {
    loginError: function() {
      return this.$store.state.apiError.userMessage
    }
  },
  methods: {
    submitForm(event) {
      event.preventDefault()
      this.login()
    },
    async login() {
      if(!this.$refs.loginForm.validate()) {
        this.$emit('error', "Both email and password are needed")
        return
      }
      await this.$store.dispatch('login', { email: this.email, password: this.password})
      if(this.loginError) {
        this.$emit('error', this.loginError)
      } else {
        // console.log('login: this.$store.state.login', this.$store.state.login)
        // console.log('login: this.$route', this.$route)
        // console.log('login: this.$store.state.login.signup_complete', this.$store.state.login.signup_complete)
        if(this.$store.state.login.signup_complete) {
          // console.log('login: signup_complete, redirecting to this.$route.query.redirect', this.$route.query.redirect)
          const otherQueryParams = { ...this.$route.query }
          delete otherQueryParams.redirect
          if(this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect, query: {...otherQueryParams} })
          } else {
            this.$router.push('home')
          }
        } else {
          // console.log('login: signup not complete, redirecting to signup-2')
          this.$router.push('signup-2')
        }
			}
    },
    async resetPassword() {
      if(!this.$refs.resetForm.validate())
        return
      await this.$store.dispatch('resetPassword', { email: this.resetEmail })
      if(this.apiError) {
        this.$emit('error', this.apiError)
      } else {
        this.resetDlg = false
        this.$emit('success', 'Password reset email has been sent')
      }
    },
  }
}
</script>

<style></style>
